import { faArrowLeft } from '@fortawesome/pro-light-svg-icons';
import { Button } from '@nazka/nazka.mapframe.components';

import { useTranslation } from '@utils/i18n/i18n.consumers';

import './item-not-found.styl';

function ItemNotFound({ goBack }) {
  const { t } = useTranslation();

  return (
    <div className="item-not-found">
      <h2>{t('The story or plan you are looking for is not available.')}</h2>
      <Button
        icon={faArrowLeft}
        onClick={goBack}
        className="item-not-found__back"
        layout="outlined"
      >
        {t('Go back')}
      </Button>
    </div>
  );
}

export default ItemNotFound;